export default "__VITE_ASSET__BW7m1bdo__"